@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: fullwidth from "../../styles/layout.module.scss";
    display: flex;
    flex-direction: column;
    gap: var(--spacer-16);
}

.alignLeft {
    composes: root;
    text-align: left;
    align-items: start;
}

.alignCenter {
    composes: root;
    text-align: center;
    align-items: center;

    // Centre the list as a block but keep each item's text beside its bullet;
    // centring every line would leave the bullets ragged.
    ul {
        width: fit-content;
        margin-inline: auto;
        text-align: left;
    }
}

.heading {
    max-width: 40ch;
    text-wrap-style: balance;

    &:last-child {
        padding-bottom: var(--spacer-8);
    }
}

.body {
    composes: richText from "../RichText/rich-text.module.scss";
    max-width: 90ch;
    text-wrap-style: balance;

    > * {
        margin-block: var(--spacer-24);
    }
}

.bodyText {
    composes: fontP20 from "../../styles/typography.module.scss";
}
